<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'GridApi',
})
</script>
<template>
  <div class="grid-api flex">
    <div class="grid-api-center">
      <div class="grid-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="item in breadcrumb.list" :key="item.id">{{
            item.name
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="grid-content">
        <div class="grid-title">{{ docData.runderData.title }}</div>
        <div class="grid-time">
          更新时间：{{ docData.runderData.updateTime }}
        </div>
        <!-- ------富文本----- -->
        <div
          class="grid-explain"
          v-for="item in docData.runderData.contentList"
          :key="item.id"
          :id="'a' + item.id"
        >
          <div class="line"></div>
          <div :id="item.id" class="maoPoint"></div>
          <div class="flex">
            <div class="explain-title">{{ item.moudleName }}</div>
          </div>
          <div
            class="ck-content"
            v-html="processMediaContent(item.moudleContent)"
          ></div>
        </div>
        <div class="footer" @click="toCustomer">
          <span> 还有疑问？联系在线客服，非技术问题在线解答</span>
          <img
            src="https://aio-qos.geovisearth.com/getfile/15/open-platform/rigArrow.webp"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="grid-api-right">
      <el-affix :offset="94" target=".document-api">
        <p class="title">本页目录</p>
        <el-anchor
          container=".home"
          @click="handleClick"
          class="anchorBox"
          :marker="false"
          ref="anchor"
          :offset="40"
        >
          <el-anchor-link
            v-for="item in docData.runderData.contentList"
            :key="item.id"
            :href="'#a' + item.id"
          >
            <span class="circle"></span
            ><span class="name">{{ item.moudleName }}</span>
          </el-anchor-link>
        </el-anchor>
      </el-affix>
    </div>
  </div>
</template>
<script setup lang="ts" name="GridApi">
import { SSRDataStore } from '@/store/modules/ssrData'
import { queryDocTree } from '@/api/modules/doc'
import { setTitle, setTDK } from '@/utils/util'
import { AffImLink } from '@/constant/global'
import { processMediaContent } from '@/utils/ckeditorMedia'
import { docDetail } from '@/api/modules/doc'
import { WEBAPI } from '@/router/constant'
import { debounce } from '@/utils/debounce'
import { getParentNodesDetail } from '@/utils/util'
import { replaceToPageByquery } from '@/utils/routerUtil'
const ssrDataStore = SSRDataStore()

const menu = shallowReactive<{ list: { [key: string]: any }[] }>({ list: [] })
const breadcrumb = shallowReactive<{ list: any[] }>({
  list: []
})

let currKey = ref<number | string>(0)
let docData = reactive<{ [key: string]: any }>({ runderData: {} })
const route = useRoute()
const docId = shallowRef<string>(String(route.query?.docId))
interface Doc {
  readonly: boolean
  menus: any[]
}
let doc: Doc = {
  readonly: false,
  menus: []
}
let idTopList = reactive<{ [key: string]: any }[]>([])
const handleClick = (e: MouseEvent, herf: string) => {
  e.preventDefault()
}
// 挂载remoteSenseScroll事件
onMounted(async () => {
  !import.meta.env.SSR &&
    window.addEventListener('scroll', remoteSenseScroll, true)
  await getDocTree()
  getDocContent()
})
const getDocContent = () => {
  if (!import.meta.env.SSR && ssrDataStore.docContentGet) {
    docData.runderData = ssrDataStore.docContentGet
    if (docData.runderData.contentList) {
      currKey.value = docData.runderData.contentList[0].id
      setTimeout(() => {
        idTopList = []
        docData.runderData.contentList.map((i: { [key: string]: any }) => {
          idTopList.push({
            id: i.id,
            top: Number(document.getElementById(i.id + 's')?.offsetTop) + 40
          })
        })
      }, 0)
    }
  } else {
    const activeMenu = getParentNodesDetail(
      menu.list,
      route.query.docId as string
    ) as {
      [key: string]: any
    }
    // 当前为开发指南时不重定向
    if (!activeMenu && route.query.docId !== '64') {
      replaceToPageByquery(WEBAPI, {
        docId: menu.list[0]?.children[0]?.id,
        detail: 'client'
      })
      return
    }
    getActiveDoc(route.query.docId?.toString())
  }
}
// 卸载remoteSenseScroll事件
onUnmounted(() => {
  !import.meta.env.SSR &&
    window.removeEventListener('scroll', remoteSenseScroll, true)
})
watch(
  () => route.query?.docId,
  () => {
    docId.value = String(route.query.docId)
    doc = {
      readonly: false,
      menus: []
    }
    breadcrumb.list = getAllParentNodes(menu.list, docId.value)!
  }
)

watch(
  () => breadcrumb.list,
  () => {
    if (breadcrumb.list.length) {
      setTitle(
        `${breadcrumb.list
          .map((item: any) => item.name)
          .join('-')}-数字地球开发平台`
      )
      setTDK(breadcrumb.list.map((item: any) => item.name).join(','))
    }
  },
  {
    immediate: true
  }
)

//滚动事件
const remoteSenseScroll = (e: Event) => {
  if (e.target instanceof HTMLDivElement) {
    const { scrollTop } = e.target
    if (scrollTop < 65) {
      currKey.value = 0
    }
    const activeLi = idTopList.find((i: any) => {
      return i.top > scrollTop
    }) as { [key: string]: any }
    currKey.value = activeLi?.id
  }
}

const getAllParentNodes = (list: { [key: string]: any }[], docId: string) => {
  for (const item of list) {
    if (!doc.readonly && doc.menus.length && item.parentId) doc.menus = []
    if (item.children.length) {
      if (!doc.readonly) doc.menus.push(item)
      getAllParentNodes(item.children, docId)
    } else {
      if (String(item.id) === docId) {
        if (!doc.readonly) {
          doc.menus.push(item)
          doc.readonly = true
        }
        return doc.menus
      }
    }
  }
  return doc.menus
}

const getDocTree = async () => {
  try {
    const res = await queryDocTree({ type: 1, rootId: 1 })
    menu.list = res.data!
    breadcrumb.list = getAllParentNodes(menu.list, docId.value)!

    if (breadcrumb.list.length) {
      setTitle(breadcrumb.list.map((item: any) => item.name).join('-'))
      setTDK(breadcrumb.list.map((item: any) => item.name).join(','))
    }
  } catch (error) {
    console.log(error, 'error')
  }
}

onServerPrefetch(async () => {
  const docId = route.query.docId?.toString()
  if (!docId) return
  await ssrDataStore.setDocContentData(docId)
  docData.runderData = ssrDataStore.docContentGet
  if (docData.runderData.contentList) {
    currKey.value = docData.runderData.contentList[0].id
  }
})

const getActiveDoc = async (docId: string | undefined) => {
  if (!docId) {
    return false
  }
  try {
    const res = await docDetail(docId)
    docData.runderData = res.data
    if (docData.runderData.contentList) {
      currKey.value = docData.runderData.contentList[0].id
      !import.meta.env.SSR &&
        setTimeout(() => {
          idTopList = []
          docData.runderData.contentList.map((i: { [key: string]: any }) => {
            idTopList.push({
              id: i.id,
              top: Number(document.getElementById(i.id + 's')?.offsetTop) + 40
            })
          })
        }, 0)
    }
  } catch (error) {
    console.log(error)
  }
}

onBeforeRouteUpdate(async (to) => {
  getActiveDoc(to.query.docId?.toString())
  setTimeout(() => {
    breadcrumb.list = getAllParentNodes(menu.list, docId.value)!
  }, 0)
})
const toCustomer = () => {
  window.open(AffImLink, '_blank')
}
</script>
<style scoped lang="scss">
@import '@/styles/ckEditor5.scss';
.grid-api {
  justify-content: space-between;
  width: 100%;
  padding-left: 2%;
  .grid-api-center {
    width: calc(98% - 280px);
    padding-bottom: 40px;
    .grid-breadcrumb {
      margin-top: 24px;
    }
    .grid-content {
      //   margin-left: 80px;
      width: 100%;
      margin-top: 32px;

      // height: 600px;
      // overflow-y: scroll;
      // overflow-x: hidden;
      .grid-title {
        font-size: 24px;
        font-weight: 700;
        color: rgba(20, 20, 25, 1);
        text-align: left;
        letter-spacing: 0;
        vertical-align: middle;
      }
      .grid-time {
        margin-top: 12px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(107, 111, 128, 1);
        text-align: left;
        letter-spacing: 0;
        vertical-align: middle;
      }
      .footer {
        margin-top: 32px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(
          270deg,
          rgba(204, 245, 255, 1) 0%,
          rgba(185, 218, 255, 1) 100%
        );
        span {
          font-size: 16px;
          font-weight: 500;
          color: #141419;
          margin-right: 9px;
          display: block;
        }
        img {
          width: 23px;
          height: 11px;
        }

        height: 56px;
        width: 100%;
        cursor: pointer;
      }
      .grid-explain {
        position: relative;
        padding-top: 32px;
        .line {
          width: 100%;
          height: 1px;
          background: rgba(230, 231, 235, 1);
          opacity: 1;
        }
        .maoPoint {
          position: absolute;
          top: -40px;
        }
        .flex {
          flex-flow: row wrap;

          //   align-content: baseline;
          //   align-items: center;
          //   border: 1px solid blue;
          .explain-title {
            font-size: 16px;
            font-weight: 700;
            color: rgba(20, 20, 25, 1);
            text-align: left;

            // border: 1px solid olivedrab;
            letter-spacing: 0;
            vertical-align: middle;
          }
        }
        .ck-content {
          display: flex;
          flex-direction: column;
          :deep(a) {
            text-decoration: none !important;
          }
          :deep(figure.table) {
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
          :deep(pre) {
            overflow: auto;
          }
        }
        .explain-title {
          margin-top: 16px;
          margin-right: 10px;
          font-size: 14px;
          font-weight: 700;
          color: rgba(20, 20, 25, 1);
          text-align: left;
          letter-spacing: 0;
          vertical-align: middle;
        }
        :deep(.table) {
          margin: 20px 0;
          margin-bottom: 0 !important;
          border-spacing: 0;
          border-collapse: collapse;
          th {
            font-weight: unset;
          }
          td,
          th {
            border-style: solid;
            border-width: 1px;
          }
        }
      }
    }
  }
  .grid-api-right {
    // margin-left: 81px;
    width: 280px;
    text-align: left;
    margin-left: 2%;
    border-left: 1px solid #e6e7eb;
    padding-left: 24px;
    .anchorBox {
      height: calc(100vh - 104px);
    }
    .el-affix {
      width: 100% !important;
      :deep(.el-anchor__list) {
        padding-left: 0;
      }
      .el-anchor__link {
        &:hover {
          .circle {
            background: #3385ff;
          }
          .name {
            color: #141419;
          }
        }
      }
      .is-active {
        .circle {
          background: #3385ff;
        }
        .name {
          color: #141419;
        }
      }
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #141419;
        margin-bottom: 16px;
      }
      .circle {
        width: 5px;
        height: 5px;
        border-radius: 2.5px;
        background: #d3d6db;
        display: inline-block;
        margin-right: 12px;
      }
    }
    .right-menu {
      margin-top: 30px;
      padding-left: 24px;
      div {
        // width: 68px;
        height: 24px;
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 400;
        color: #6b6f80;
        text-align: left;
        letter-spacing: 0 px;
        vertical-align: middle;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
